<template>

    <v-container>
        <h2 class="mt-3 mb-3">Create New Playlist</h2>
      <v-form>
        
        <v-text-field outlined v-model="playlistName" label="Playlist Name*" :rules="[v => !!v || 'Please Enter Playlist Name']"></v-text-field>
        <v-text-field outlined v-model="playlistUser" label="User Name" ></v-text-field>

        <v-text-field outlined v-model="playlistImage" label="Image Url"></v-text-field>
        <div v-if=selectedSongs.length><h4>Selected Songs</h4>
        <playlist-song v-for="song in selectedSongs" :key="song.id" :song="song">
                  <template #default><v-btn icon class="ml-3"> <v-icon>mdi-play</v-icon></v-btn></template></playlist-song><br>
        </div>
        
        <v-text-field class="box" outlined v-model="search" label="Search Songs" append-icon="mdi-magnify" @click="toggleSongList"
      ></v-text-field>
      <div v-show="isSongListVisible">
        <playlist-song v-for="song in filteredSongs" :key="song.id" :song="song" >
        <template #default><v-btn icon class="ml-3" @click="addToSelectedSongs(song)"> <v-icon>mdi-plus</v-icon></v-btn></template>
        </playlist-song>
      
      </div>
       
      <br>
    <v-btn dark class="mr-3"><router-link :to="'/playlists'">Back</router-link></v-btn><v-btn  color="green" @click="addPlaylist" :disabled="!isFormValid">Save Playlist</v-btn>
      </v-form>
    </v-container>

</template>
<script>
import apiService from "@/apiService.js";
import PlaylistSong from '@/components/PlaylistSong.vue';

export default {
   components: {
    PlaylistSong
  },
  data() {
    return {
      playlistName: "",
      playlistUser: "",
      playlistImage: "",
      search: "",
      songs: [],
      selectedSongs: [],
      isSongListVisible: false
    };
  },
  computed: {
    isFormValid() {
      return this.playlistName && this.selectedSongs.length > 0;
    },
    filteredSongs() {
      return this.songs.filter(song => song.name.toLowerCase().includes(this.search.toLowerCase()));
    },
  },
  mounted() {
    this.fetchSongs();
  },
  methods: {
    fetchSongs() {
      this.songs = apiService.getSongs();
    },
    toggleSongList() {
      this.isSongListVisible = !this.isSongListVisible;
    },
    addToSelectedSongs(song) {
      this.selectedSongs.push(song);
      this.songs = this.songs.filter(s => s.id !== song.id);
    },

    addPlaylist() {
       if (this.isFormValid) {
       const newPlaylist = {
        name: this.playlistName,
        user: this.playlistUser,
        image: this.playlistImage,
        songIds: this.selectedSongs.map(song => song.id),
      };
      apiService.addPlaylist(newPlaylist);
     
      this.$router.push('/playlists');
      }
    }
}
}
</script>
<style scoped>
   ul {
    margin-top: 0;
    list-style-type: none;
    padding: 0;
  }
 .song{
  display:flex;
  align-items:center;
 }
  li {
    
    border: 1px solid #ccc;
    padding: 10px;
   
  } 
a{
  text-decoration: none;
  color:white !important;
}
.box{
  margin-bottom: -30px;
}
</style>